
export const PAGE_ROUTES = {
  HOME: "/",
  SERVICES: "/#services",
  CORPORATE: "/corporate-offerings",
  BOOK: "/book-a-consultation",
  STORE: "/store",
  PRODUCT: "/product/:id",
  THANK_YOU: "/thank-you",
  CANCEL_SUBSCRIPTION: "/cancel-subscription",
  CONTACT: "/contact",
  MEAL_PLAN_FORM: "/meal-plan-questionnaire",
  EBOOK: "/download-your-free-recipe-e-book",
  WELCOME: "/welcome",
};

export const LOADING_STATE = {
  NOT_LOADING: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
};

export const STORE_FILTERS = {
  ALL: "All",
  MEAL_PLANS: "Meal Plans",
  EXERCISE_PLANS: "Exercise Plans",
  HEALTH_GUIDES: "Health Guides",
};
